// extracted by mini-css-extract-plugin
module.exports = {"esgDistributionBarChart":"EsgDistributionBarChartView_esgDistributionBarChart__1IZlW","barChart":"EsgDistributionBarChartView_barChart__yJ_2O"};